// List of locales where we can support collecting feedback from users
export const FEEDBACK_LOCALES = ['en-GB', 'en-US', 'en-AU'];
